<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'95%'"
    :classDialog="'dialogTransferHandling'"
    :offsetTop="'8vh'"
    :appendToBody="true"
    :modalAppendToBody="true"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="title flex-row">
        <h2 class="dialogTitle">
          Chuyển xử lý cá nhân
        </h2>
        &nbsp;&nbsp;
        <div class="title-content">
          <el-tag class="priority lv3">
            {{quote || '-'}}
          </el-tag>
        </div>
      </div>
      <!-- body -->
      <el-row
        class="dialog-body margin-0"
        :gutter="24"
      >

        <el-col
          :span="12"
          class="list-collapse__transfer"
        >
          <h4 class="margin-bottom-10">Danh sách chuyển xử lý</h4>
          <div class="flex-row flex__left margin-bottom-10">
            <el-input
              prefix-icon="el-icon-search"
              v-model="search"
              size="medium"
              placeholder="Tìm kiếm cá nhân"
              @keydown.enter.exact.native="searchTree"
            ></el-input>
          </div>
          <VuePerfectScrollbar class="scroll-area scroll-area-height_90">
            <el-tree
              :data="departmentTree"
              :filter-node-method="filterDepartmentTreeNode"
              ref="departmentTree"
              :expand-on-click-node="false"
              class="filter-tree"
              default-expand-all
            >
              <div
                class="custom-tree-node flex-row flex__between width__100"
                slot-scope="{ node, data }"
              >
                <div class="field-1">
                  <span
                    v-if="[DEPARTMENT_TREE.NODE_TYPE.DVTT, DEPARTMENT_TREE.NODE_TYPE.PBCN, DEPARTMENT_TREE.NODE_TYPE.HDTV, DEPARTMENT_TREE.NODE_TYPE.BTGD, DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT, DEPARTMENT_TREE.NODE_TYPE.DEPT].indexOf(data.nodeType) != -1">
                    <el-checkbox
                      v-if="node.visible"
                      @click.native.stop="() => true"
                      @change="selectAll(data)"
                    ></el-checkbox>
                    <span>&nbsp;{{ getNodeLabel(data) }}</span>
                  </span>

                  <span v-else-if="DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE == data.nodeType">
                    <el-checkbox
                      @click.native.stop="() => true"
                      @change="nodeCheckedChange($event, data)"
                      v-model="data.checked"
                    ></el-checkbox>
                    <span @click="nodeCheckedChange(data.checked = !data.checked, data)">
                      &nbsp;
                      <span class="font-weight__bold">
                        {{ data.handler.userView.fullName }}
                      </span>
                      <span class="font-size__small font-italic">
                        ({{data.handler.userView.positionName}} - {{data.handler.userView.deptName}})
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </el-tree>
          </VuePerfectScrollbar>
        </el-col>

        <el-col
          :span="12"
          class="display-list__selected"
        >
          <!-- chuyen xu ly -->
          <div class="list-selected">
            <!-- title -->
            <div class="header">
              <div class="flex-row flex__between">
                <h5 class="title margin-0">Danh sách chuyển xử lý</h5>
                <div class="list-checkbox flex-row flex__right margin-right-10">
                  <h5 class="margin-0 item flex-col flex__center radio_chuyenXuLy">
                    <span class="margin-bottom-5">Chủ trì</span>
                    <span>
                      <el-radio
                        v-model="dataCheckAll"
                        :label="PROCESS_TYPE.CHUTRI"
                        @change="checkAllRadio"
                        class="radio_chuyenXuLy"
                      ></el-radio>
                    </span>
                  </h5>
                  <h5 class="margin-0 item flex-col flex__center radio_chuyenXuLy">
                    <span class="margin-bottom-5">Phối hợp</span>
                    <span>
                      <el-radio
                        v-model="dataCheckAll"
                        :label="PROCESS_TYPE.PHOIHOP"
                        @change="checkAllRadio"
                        class="radio_chuyenXuLy"
                      >
                      </el-radio>
                    </span>
                  </h5>
                  <h5 class="margin-0 item flex-col flex__center radio_chuyenXuLy">
                    <span class="margin-bottom-5">Nhận để biết</span>
                    <span>
                      <el-radio
                        v-model="dataCheckAll"
                        :label="PROCESS_TYPE.NHANDEBIET"
                        @change="checkAllRadio"
                        class="radio_chuyenXuLy"
                      >
                      </el-radio>
                    </span>
                  </h5>
                </div>
              </div>
            </div>
            <!-- end_title -->
            <div class="body">
              <div class="list-filter">
                <VuePerfectScrollbar
                  class="scroll-list-user"
                  :settings="perfectScrollbarSetting"
                >
                  <div
                    v-for="(node, index) in selectedNodes"
                    :key="index"
                    class="selected-user flex-row flex__between"
                  >
                    <div class="title flex-row flex__left">
                      <div class="clickable margin-right-10">
                        {{index + 1}}.
                      </div>
                      <div class="flex-row flex__left">
                        <div class="avt">
                          <div
                            v-if="node.handler && node.handler.url"
                            v-bind:style="{ 'background-image': 'url(' + handler.url + ')' }"
                          ></div>
                          <div
                            v-else
                            class="avatar-fake font-size__small margin-right-10 flex-row flex__center"
                          >
                            <span>{{node.handler ? buildShortName(node.handler.userView.fullName) : buildShortName(node.department.deptName)}}</span>
                          </div>
                        </div>
                        <div class="info">
                          <p class="people__name">{{node.handler ? node.handler.userView.fullName :
                            node.department.deptName}}</p>
                          <p
                            class="people__position margin-0"
                            v-if="node.handler"
                          >
                            {{node.handler.userView.positionName}} - {{node.handler.userView.deptName}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="list-checkbox flex-row flex__right margin-right-10">

                      <template>
                        <el-radio
                          class="item txt-center"
                          v-model="node.processType"
                          :label="PROCESS_TYPE.CHUTRI"
                          @change="removeCheckAllRadio"
                        >&nbsp;
                        </el-radio>
                        <el-radio
                          class="item txt-center"
                          v-model="node.processType"
                          :label="PROCESS_TYPE.PHOIHOP"
                          @change="removeCheckAllRadio"
                        >
                          &nbsp;
                        </el-radio>
                        <el-radio
                          class="item txt-center"
                          v-model="node.processType"
                          :label="PROCESS_TYPE.NHANDEBIET"
                          @change="removeCheckAllRadio"
                        >
                          &nbsp;
                        </el-radio>
                      </template>

                      <i
                        @click="removeSelectedNode(node)"
                        class="icon-close color__red clickable font-size__medium el-icon-circle-close"
                      ></i>
                    </div>
                  </div>
                </VuePerfectScrollbar>
              </div>
            </div>
          </div>
          <!--          <el-form-->
          <!--              label-position="top"-->
          <!--              :model="form"-->
          <!--          >-->
          <!--            <el-form-item label="Ý kiến chỉ đạo/đề xuất">-->
          <!--              <el-input-->
          <!--                  type="textarea"-->
          <!--                  resize="none"-->
          <!--                  :autosize="{ minRows: 2, maxRows: 2}"-->
          <!--                  v-model="form.note"-->
          <!--                  placeholder="_"-->
          <!--              />-->
          <!--            </el-form-item>-->
          <!--          </el-form>-->

        </el-col>
      </el-row>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          class="dialogBtnPrimary"
          @click="chuyenXuLi"
        >
          <i class="fas fa-check-circle font-size__small"></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fal fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>
<script>

  import h from "../../../services/h";
  import utils from '../../../services/utils';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import nextStepInfoViewService from "../../../services/nextStepInfoViewService";
  import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
  import buildShortNameFilter from '../../../filters/buildShortNameFilter.js';
  import constants from '../../../constants';
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import displayDepartmentTreeMixin from "../../../mixins/displayDepartmentTreeMixin";


  export default {

    mixins: [handleRequestErrorMixin, displayDepartmentTreeMixin],
    filters: {buildShortNameFilter},
    props: ["isOpen", "flowId", "selectedNodes", "quote"],
    components: {
      dialogTemplate: () => import('../../common/custom-dialog.vue'),
      chuyenXuLyHashtag: () => import('./chuyenXuLy-hashtag.vue'),
      VuePerfectScrollbar
    },

    computed: {
      parentRoute() {
        return this.$route.path.split("/")[3];
      },
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      }
    },

    name: 'Transfer',

    data() {
      return {

        dataCheckAll: {},

        stepId: null,
        docId: null,

        select: {
          CHUTRI: false,
          PHOIHOP: false,
          NHANDEBIET: false
        },

        keyword: null,
        handlers: [],

        departments: [],
        loadUsersForNextStepFlag: 0,
        search: null,
        DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
        DEPARTMENT: constants.DEPARTMENT,
        PROCESS_TYPE: constants.PROCESS_TYPE,

        vbIncomingProcess: null,

        isEnableCXLCaNhan: false,
        isEnableCXLDonVi: false,

        nextStepsCaNhan: null,
        nextStepsDonVi: null,
        listDeptIdsHasChuyenTiep: [],
        listDeptIds: []
      }
    },

    watch: {
      nextStepsCaNhan(newValue) {
        if (newValue) {
          this.isEnableCXLCaNhan = true;
        }
      },

      nextStepsDonVi(newValue) {
        if (newValue) {
          this.isEnableCXLDonVi = true;
        }
      },

      loadUsersForNextStepFlag(newValue) {
        if (!newValue) {
          this.buildHandlerNodes();
          this.$nextTick(() => this.searchTree());
        }
      },
    },

    created() {
      this.loadDepartments().then(() => {
        this.addHDTVAndBTGDNodes();
        this.loadNextStep();
      });
    },

    methods: {

      checkAllRadio(value) {
        // console.log(value)
        for (let i = 0; i < this.selectedNodes.length; i++) {
          this.$set(this.selectedNodes[i], 'processType', value);
        }
      },
      removeCheckAllRadio() {
        this.dataCheckAll = null;
      },


      selectAll(node) {
        if (this.isEnableCXLCaNhan) {
          this.selectAll_(node);
          this.searchTree();
        }
        if (this.isEnableCXLDonVi) {
          this.selectAllDonVi_(node);
          this.searchTree();
        }

      },

      selectAll_(node) {
        h.each(node.children, childNode => {
          if (!childNode) return;
          if (childNode.nodeType == constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE) {
            if (!childNode.checked) {
              childNode.checked = true;
              this.selectedNodes.push(childNode);
            }
          } else {
            this.selectAll_(childNode);
          }
        });
      },

      selectAllDonVi_(node) {
        if (this.listDeptIds.indexOf(node.department.id) > -1) {
          this.$set(node, 'processType', constants.PROCESS_TYPE.CHUTRI);
          this.selectedNodes.push(node)
        }
        if (node.children.length == 0) return;
        h.each(node.children, childNode => {
          if (!childNode || childNode.nodeType == constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE || this.listDeptIds.indexOf(childNode.department.id) == -1) return;
          if (childNode.nodeType == constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
            this.listDeptIds.indexOf(childNode.department.id) != -1) {
            if (!childNode.checked) {
              childNode.checked = true;
              this.$set(childNode, 'processType', constants.PROCESS_TYPE.CHUTRI);
              this.selectedNodes.push(childNode);
            }
          } else {
            this.selectAllDonVi_(childNode);
          }
        });
      },


      removeSelectedNode(node) {
        node.checked = false;
        node.processType = null;
        this.selectedNodes.splice(this.selectedNodes.indexOf(node), 1);
        this.searchTree();
      },

      nodeCheckedChange(checked, node) {
        if (!checked) return;
        this.$set(node, 'processType', constants.PROCESS_TYPE.CHUTRI);
        this.selectedNodes.push(node);
        this.searchTree();
      },

      /**
       * chỉ search những node nào hiển thị người chưa nằm trong danh sách chuyển xử lí;
       */
      filterDepartmentTreeNode(value, data) {

        return (data.handler && (!value ? true : (data.handler.userView.fullName || "").toUpperCase().indexOf(value.toUpperCase()) !== -1) ||
          data.department && (!value ? true : (data.department.deptName || "").toUpperCase().indexOf(value.toUpperCase()) !== -1)) &&
          (this.selectedNodes.indexOf(data) == -1) &&
          ((data.nodeType == this.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
            this.listDeptIds.indexOf(data.department.id) != -1 ||
            data.nodeType == this.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE && data.handler.userView.id != this.userDeptRole.id));
      },


      /**
       * add thêm 2 node hội-đồng-thành-vien & ban-tổng-giám-đốc;
       */
      addHDTVAndBTGDNodes() {
        h.each(this.departmentTree, (root) =>
          utils.duyetTree(
            root,
            (node) => node.children,
            (node) => {
              let nodeType = node.nodeType;
              let department = node.department;
              if (nodeType == this.DEPARTMENT_TREE.NODE_TYPE.DEPT && department.deptCode == this.DEPARTMENT.DEPT_CODE.TCT) {
                //nếu là node Tổng công ty thì thực hiện thêm 1 node con là hội-đồng-thành-vien & ban-tổng-giám-đốc;
                node.children = [{
                  nodeType: this.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT,
                  department: department
                }].concat(node.children || []);
              } else if (nodeType == this.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT) {
                //nếu là node Tổng công ty thì thực hiện thêm 2 node con là hội-đồng-thành-vien -  ban-tổng-giám-đốc;
                node.children = [
                  {nodeType: this.DEPARTMENT_TREE.NODE_TYPE.HDTV, department: department},
                  {nodeType: this.DEPARTMENT_TREE.NODE_TYPE.BTGD, department: department},
                ]
              }
            },
            null,
          )
        )
      },

      buildHandlerNodes() {

        let buildDataForHandlerNodeFn = (handler) => {
          return {nodeType: this.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE, handler: handler, checked: false}
        };

        let isHDTVFn = (handler) => handler.positionName == constants.POSITION.NAME.THANH_VIEN_HDTV;
        let isBTGDFn = (handler) => [constants.POSITION.NAME.TGĐ, constants.POSITION.NAME.PTGĐ].indexOf(handler.positionName) != -1;

        h.each(this.departmentTree, (root) =>
          utils.duyetTree(
            root,
            (node) => node.children,
            (node) => true,
            (node) => {
              let nodeType = node.nodeType;
              let department = node.department;

              switch (nodeType) {
                case this.DEPARTMENT_TREE.NODE_TYPE.DEPT:
                  if (department.deptCode != this.DEPARTMENT.DEPT_CODE.TCT) {
                    node.children = h.collect(
                      h.findAll(this.handlers, handler => handler.userView.deptId == department.id),
                      handler => buildDataForHandlerNodeFn(handler),
                    ).concat(node.children);
                  } else {
                    node.children = h.collect(
                      h.findAll(this.handlers, handler => handler.userView.deptId == department.id && !isHDTVFn(handler) && !isBTGDFn(handler)),
                      handler => buildDataForHandlerNodeFn(handler),
                    ).concat(node.children);
                  }
                  break;

                case this.DEPARTMENT_TREE.NODE_TYPE.BTGD:
                  node.children = h.collect(
                    h.findAll(this.handlers, handler => handler.userView.deptId == department.id && isBTGDFn(handler)),
                    handler => buildDataForHandlerNodeFn(handler),
                  ).concat(node.children);
                  break;

                case this.DEPARTMENT_TREE.NODE_TYPE.HDTV:
                  node.children = h.collect(
                    h.findAll(this.handlers, handler => handler.userView.deptId == department.id && isHDTVFn(handler)),
                    handler => buildDataForHandlerNodeFn(handler),
                  ).concat(node.children);
                  break;
              }
            },
          )
        );
      },

      searchTree() {
        this.$refs.departmentTree.filter(this.search);
      },

      handleRequestError(error) {
        this.$message({message: errorMessageFilter(error), type: 'error'});
        return true;
      },

      buildShortName(fullName) {
        return utils.buildShortName(fullName);
      },

      validate() {

        let count = this.selectedNodes.length;

        if (!count) {
          this.notify("Lỗi", "Danh sách chuyển xử lý chưa nhập !", "error", 2000);
          return false;
        }

        return true;
      },

      chuyenXuLi() {

        if (!this.validate()) return;
        // let processHandlerForms = this.selectedNodes
        // 	.filter(node => node.nodeType == constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE)
        // 	.map(node => {
        // 		return {
        // 			userId: node.handler.userView.userId,
        // 			deptId: node.handler.userView.deptId,
        // 			roleId: node.handler.userView.roleId,
        // 			positionId: node.handler.userView.positionId,
        // 			processType: node.processType,
        // 			stepId: node.handler.stepId,
        // 			delegateInfoId: node.handler.userView.delegateInfoId
        // 		}
        // 	})
        //
        // let processHandlerDeptForms = this.selectedNodes
        // 	.filter(node => node.nodeType == constants.DEPARTMENT_TREE.NODE_TYPE.DEPT)
        // 	.map(node => {
        // 		return {
        // 			deptId: node.department.id,
        // 			stepId: this.stepId,
        // 			processType: node.processType
        // 		}
        // 	});

        this.$emit("selectHandler", {
          selectedNodes: this.selectedNodes,
        })

      },

      loadNextStep() {
        this.handlers = [];
        nextStepInfoViewService.nextSteps(this.flowId, null).then(response => {
          this.nextStepsCaNhan = h.findAll(
            response.data,
            item => item.stepType === constants.STEP.STEP_TYPE.CANHAN
          );

          this.nextStepsDonVi = h.findAll(
            response.data,
            item => item.stepType === constants.STEP.STEP_TYPE.DONVI
          );
          h.each(this.nextStepsCaNhan, item => {
            this.loadUsersForNextStepFlag++;
            this.loadUsersForNextStep(item).then(() => this.loadUsersForNextStepFlag--)
          });
          h.each(this.nextStepsDonVi, item => this.loadDeptForNextStep(item));
        });
      },

      loadDeptForNextStep(nextStep) {
        if (!nextStep.deptId) return;
        this.listDeptIds.push(nextStep.deptId);
      },

      loadUsersForNextStep(nextStep) {
        return userDeptRoleViewService
          .findAllActiveForStepInfo(nextStep.vbStepInfoId)
          .then(response => {
            let users = h.findAll(response.data, item => item.status == constants.USER_DEPT_ROLE.STATUS.ACTIVE);
            this.handlers = this.handlers.concat(
              h.collect(users, userView => {
                return {
                  id: userView.id,
                  userView: userView,
                  stepId: nextStep.id
                };
              })
            );
          });
      },
    },

  }
</script>
<style scoped>
  .title {
    width: 100%;
  }

  .list-checkbox {
    position: relative;
    margin-right: 25px;
  }

  .scroll-list-user {
    height: auto;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    padding-right: 3px;
  }

  .list-checkbox .item {
    width: 100px;
    text-align: center;
    margin: 0;
  }

  .icon-close {
    position: absolute;
    right: -5px;
    font-size: 18px;
  }

  .dialog-body .display-list__selected .list-selected .header > div {
    width: 100%;
  }

  .dialog-body .display-list__selected .list-selected .body {
    padding: 0;
  }

  .dialogTransferHandling .dialog-body .scroll-area-height_90 {
    height: 70%;
  }

  .dialog-body .display-list__selected {
    height: 400px;
  }

  .dialogTransferHandling .dialog-body .display-list__selected .list-selected {
    height: calc(100% - 15px);
  }

  .dialog-body .display-list__selected .list-selected .header {
    padding-left: 10px;
    padding-right: 10px;
  }

  .dialog-body .display-list__selected .list-selected .body .list-filter {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/TransferNewVanThu.vue